import { createDocumentPage, getDocumentTextForType } from "./documentBaseUtils";

export function generatePrintRenewPermitHtml(config, data, user, breakNewPage = false) {
    const { getDocumentText } = getDocumentTextForType(data, config);
    return createDocumentPage({title: 'DECLARAÇÃO',  documentText: getDocumentText('RENOVACAO_ALVARA'), config, data, user}, {showUserName: true, compact: true, breakNewPage: breakNewPage});
}
